import React from 'react';
import loadingSvg from '../../assets/loading/loading.svg';
import './Loading.scss';

/**
 * Loading component with animated SVG
 * @param {Object} props
 * @param {string} props.size - Size of the loading animation ('small', 'medium', 'large', or custom CSS value)
 * @param {string} props.className - Additional CSS classes
 * @param {string} props.text - Optional text to display below the loading animation
 * @param {boolean} props.inline - If true, displays inline (flex row), otherwise block
 */
const Loading = ({ 
  size = 'medium', 
  className = '', 
  text = '', 
  inline = false 
}) => {
  const sizeMap = {
    small: '24px',
    medium: '48px',
    large: '72px'
  };

  const loadingSize = sizeMap[size] || size;

  const style = { '--loading-size': loadingSize };

  return (
    <div 
      className={`loading-container ${inline ? 'loading-inline' : ''} ${className}`}
      style={style}
    >
      <img 
        src={loadingSvg} 
        alt="Loading..." 
        className="loading-animation"
      />
      {text && <span className="loading-text">{text}</span>}
    </div>
  );
};

export default Loading;
